import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveDraft } from '../../actions/draft';
import { TDispatch } from '../../types/reducers';
import { selectIsSaveDraftButtonAvailable, selectIsSaveDraftButtonDisabled } from '../../selectors/checkoutInfo';
import { selectIsSaveDraftPending } from '../../selectors/draft';
import { SaveDraftButton } from './SaveDraftButton';

export const SaveDraftButtonContainer = () => {
  const isSaveDraftButtonAvailable = useSelector(selectIsSaveDraftButtonAvailable);
  const isSaveDraftButtonDisabled = useSelector(selectIsSaveDraftButtonDisabled);
  const isPending = useSelector(selectIsSaveDraftPending);

  const dispatch = useDispatch<TDispatch>();

  const handleButtonClick = React.useCallback(() => {
    dispatch(saveDraft());
  }, [dispatch]);

  if (!isSaveDraftButtonAvailable) {
    return null;
  }

  return <SaveDraftButton isDisabled={isSaveDraftButtonDisabled} isPending={isPending} onClick={handleButtonClick} />;
};
